export default {
  BIOMETHANE: 'BIOMETHANE_GAS_TYPE',
  HYDROGEN: 'HYDROGEN_GAS_TYPE',
};
